import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-gray-800 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 w-full" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "flex items-center justify-between mb-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "bg-gray-700 h-12 w-12 rounded-full flex items-center justify-center text-green-500 text-xl font-semibold mr-3" }
const _hoisted_6 = { class: "flex items-center mt-1 text-purple-400" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "flex items-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getUserInitials()), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: `/profile/${_ctx.user.id}`,
              class: "text-blue-400 font-semibold hover:text-blue-300 transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.user.username), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.city), 1)
            ])
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFollow && _ctx.toggleFollow(...args)), ["stop","prevent"])),
          class: _normalizeClass(["bg-gray-700 hover:bg-gray-600 text-white px-3 py-2 rounded-md text-sm transition-colors flex items-center", { 'opacity-70': _ctx.isLoading }]),
          disabled: _ctx.isLoading
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["h-4 w-4 mr-1", { 'text-red-400': true }]),
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
              "clip-rule": "evenodd"
            }, null, -1)
          ]))),
          _cache[3] || (_cache[3] = _createTextVNode(" Otprati "))
        ], 10, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: `/profile/${_ctx.user.id}`,
          class: "text-green-500 hover:text-green-400 transition-colors text-sm flex items-center"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-4 w-4 mr-1",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }),
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                "clip-rule": "evenodd"
              })
            ], -1),
            _createTextVNode(" Pogledaj profil ")
          ])),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}